"use strict";
exports.__esModule = true;
var Padding = /** @class */ (function () {
    function Padding() {
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
        this.right = 0;
    }
    return Padding;
}());
exports.Padding = Padding;
//# sourceMappingURL=padding.js.map